// Chart configuration constants
export const DEFAULT_CHART_WIDTH = "half_page";

export const CHART_COLORS = [
  "#e87722",
  "#204F56",
  "#E025A5",
  "#530FDD",
  "#00B1AD",
  "#47292B",
  "#B00020",
];

export const CHART_DIMENSIONS = {
  HEIGHT: 450,
  WIDTH: "100%",
  EXPORT_WIDTH: 700,
};

export const SLIDE_DIMENSIONS = {
  WIDTH_INCHES: 7,
  HEIGHT_INCHES: 5.3,
  IMAGE_WIDTH_FRACTION: 0.7,
  IMAGE_HEIGHT_FRACTION: 0.6,
};

export const SPECIAL_REPORT_TABS = [
  "cullinghistory",
  "snapsix",
  "periodcomparison",
  "subherdcomparison",
];

export const CHART_IDS = {
  ECM: "ecmchart",
  TEST_DAY_MILK: "testdaymilkchart",
  WEEKLY_MILK: "weeklymilkchart",
  LACTATION_1: "lactation1chart",
  LACTATION_2: "lactation2chart",
  LACTATION_3: "lactation3chart",
  HERD_DATA: "herddatachart",
  CALF_HEIFER: "calfheiferchart",
  DAYS_OPEN: "daysopenchart",
  PERCENT_FAT: "percentfatchart",
  SOMATIC_CELL: "somaticcellchart",
  PERCENT_PROTEIN: "percentproteinchart",
  TOTAL_LBS: "totallbschart",
  AVG_DIM: "avgdimchart",
  CALVING_INTERVAL: "calvingintervalchart",
  ANNUAL_CULL: "annualcullchart",
  LACTATION_CURVE: "lactationcurvechart",
};

export const TICK_AMOUNTS = {
  PERCENT_FAT: 6,
  PERCENT_PROTEIN: 5,
  TOTAL_LBS_DEFAULT: 4,
};

export const AXIS_LABELS = {
  DAYS_IN_MILK: "Days in Milk",
  WEEKS_IN_MILK: "Weeks in Milk",
  TEST_DAY_MILK: "Test Day Milk",
  WEEKLY_MILK: "Weekly Milk",
  ENERGY_CORRECTED_MILK: "Energy Corrected Milk",
};

export const WEEK_TICK_VALUES = Array.from({ length: 44 }, (_, i) => i + 1);

export const HERD_GOAL_NAMES = ["Herd_Goal_(60)", "Herd_Goal_(115)"];

// Lactation chart styling configurations by report tab
export const LACTATION_STYLES = {
  snapshot: {
    colors: [
      "rgb(232, 119, 34)", // test_day - solid orange
      "rgba(32, 79, 86, .5)", // Herd_Goal_(60) - light teal dashed
      "rgb(32, 79, 86)", // Herd_Goal_(115) - solid teal
      "rgba(32, 79, 86, .5)", // extra goal - light teal dashed
      "rgba(224, 37, 165, 1)", // Peer/National - solid pink
    ],
    dashArray: [null, 10, null, 10, null],
    markerWidths: [20, 10, 20, 10, 20],
  },
  periodcomparison: {
    colors: [
      "rgb(232, 119, 34)", // test_day_1 - solid orange
      "rgb(37, 150, 190)", // test_day_2 - solid blue
      "rgba(32, 79, 86, .5)", // Herd_Goal_(60) - light teal dashed
      "rgb(32, 79, 86)", // Herd_Goal_(115) - solid teal
      "rgba(32, 79, 86, .5)", // extra goal - light teal dashed
    ],
    dashArray: [null, null, 10, null, 10],
    markerWidths: [20, 20, 8, 20, 8],
  },
  subherdcomparison: {
    colors: [
      "rgb(232, 119, 34)",
      "rgb(32, 79, 86)",
      "rgba(224, 37, 165, 1)",
      "rgba(83, 15, 221, 1)",
      "rgba(0, 177, 173, 1)",
      "rgba(71, 41, 43, 1)",
      "rgba(176, 0, 32, 1)",
    ],
    dashArray: [null, null, null, null, null, null, null],
    markerWidths: [20, 20, 20, 20, 20, 20, 20],
  },
  lactationCurve: {
    dashArray: [null, null, null, 10, 10, 10, 5, 5, 5],
    // Marker widths are calculated dynamically based on series count
  },
};
